import { Component, OnInit, Input, ViewEncapsulation, signal, computed, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Settings } from '../flows/settings';
import { MsalHelperService } from '../services/msal-helper.service';
import { StorageRouterService } from '../services/storage-router.service';
//import { AnalyticsService } from '../services/analytics.service';
import { Breakpoints, BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ApplicationInsightsService } from '../services/application-insights.service';
import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { SubscriptionPaymentComponent } from '../subscription-payment/subscription-payment.component';
import { PaymentService } from '../services/payment.service';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import * as constants from '../constants';

const PRODUCT_NAME = 'FlowStudio';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class AboutComponent implements OnInit {


  @Input() user$: BehaviorSubject<any>;
  resLayout: ('desktop' | 'mobile' | 'mobile-topics')  = 'desktop';  // 

  @Input() footer = true;
  productYearly = false;
  showMcpVideo = false;
  @ViewChild('mcpHeroVideo') mcpHeroVideo?: ElementRef<HTMLVideoElement>;
  constants = constants;

  private locationSig = signal(window.location.host.toLowerCase());
  isApp = computed(() => !environment.web && (this.locationSig().startsWith('localhost:') || ['dev.flowstudio.app', 'prod.flowstudio.app'].includes(this.locationSig())));

  constructor(
    private router: Router, 
    // private route: ActivatedRoute,
    private msalHelperService: MsalHelperService,
    private storageDexieService: StorageRouterService,
    //private analytics: AnalyticsService,
    private appInsights: ApplicationInsightsService,
    // private flowManagementService: FlowManagementService,
    private dialogService: DialogService,
    private breakpointObserver: BreakpointObserver,
    private paymentService: PaymentService
  ) { }

  ngOnInit() {

    this.user$ = this.msalHelperService.user$;

    this.breakpointObserver
      .observe([Breakpoints.Small, Breakpoints.HandsetPortrait])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {

        console.log(
            'Matches small viewport or handset in portrait mode'
        );
        }

        this.resLayout = state.matches ? 'mobile' : 'desktop';
    }
    );

  }

  navigate(url: string) {
    this.router.navigateByUrl(url);
    // setTimeout(()=>{
    //     this.selectTab();
    // },1);
  }

  login($event) {

    //this.analytics.send("app", "login");
    //this.appInsights.logPageView(`app: login`);
    // this.appInsights.trackEvent(`app`, { "select": "login" });
    // this.msalHelperService.login();
    $event.stopPropagation();
    this.router.navigate(['/login']);

  }

  welcomeBack($event) {
    $event.stopPropagation();

    this.storageDexieService.getConfig(Settings.SETTING_LASTROUTE).then(setting=>{
        let route = setting?.value || "/flows";
        if (route === '/' || route.startsWith('/settings')) {
            route = '/flows';
        }

        this.msalHelperService.continueLogin(route);
    })

      // this.getLastRoute().then(route=>{
      //     //this.ready = true;                
      // });    
  }

  public showSubscription() {
    const dialogRef = this.dialogService.open({
        title: `Purchase ${PRODUCT_NAME} Subscription`,
        content: SubscriptionPaymentComponent,
        minWidth: 700,
        width: 900,
        // actions: [
        //     { text: 'No' },
        //     { text: 'Yes', primary: true }
        // ]
    });

    // dialogRef.result.toPromise().then((result: DialogCloseResult) => {
    //     return this.storageDexieService.updateSettings({ _id: Settings.SETTING_LASTSUB, value: LAST_SUB });
    // });
  }

  public buy(plan: 'pro' | 'teams') {
    if (this.user$?.value) {
      this.paymentService.checkout(plan, this.productYearly);
    } else {
      sessionStorage.setItem('fs_buy_intent', JSON.stringify({ plan, yearly: this.productYearly }));
      this.router.navigate(['/login']);
    }
  }

  toggleMcpVideo($event: Event) {
    $event.stopPropagation();
    this.showMcpVideo = !this.showMcpVideo;

    const video = this.mcpHeroVideo?.nativeElement;
    if (!video) return;

    if (this.showMcpVideo) {
      setTimeout(() => {
        video.play().catch(() => {
          // Ignore browser play restrictions.
        });
      }, 0);
      return;
    }

    video.pause();
  }

}
